(async () => {
    const { updateURLParams, requestFilter, cancelFilterRequest } = await import(window.theme.modules.utils);
    const baseComponent = await import(window.theme.modules.baseComponent);
    customElements.define('active-filter', class extends baseComponent.default {
        render() {
            this.addEventListener('click', e => {
                if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                const href = this.getAttribute('url');
                if (!href) return;
                e.preventDefault();
                const urls = updateURLParams({}, this.sectionId, href);
                requestFilter(this, urls, 'active-filters', () => {
                    if (this.hasAttribute('price')) this.trigger('resetPriceFilter');
                });
            });
        }
        disconnectedCallback() {
            cancelFilterRequest(this);
            super.disconnectedCallback();
        }
    });
})();